import { DeliveryType } from "@omni/types/api/product/bff/shared/enums/deliveryType.enum";
import { StepVariables } from "@omni/types/components/tracking/tracking-info/tools/toolStep.trackingInfo";

import { CartModel } from "@/redux/modules/api/data/cart/@types/cart.model";
import { OrderDetailsModel } from "@/redux/modules/api/data/orderDetail/@types/orderDetails.model";
import { toCartImpressionTrackingInfo } from "@/services/tracking/mappers/cart.mapper";
import { getOrderDetailsImpressionTrackingInfo } from "@/services/tracking/mappers/order.mapper";
import {
    TOOL_CHECKOUT_CONTEXT,
    TOOL_CHECKOUT_STEPS
} from "@/services/tracking/trackers/tools/checkout/config";
import * as ToolsStepTracker from "@/services/tracking/trackers/tools/toolStep.tracker";
import { getUserInfo } from "@/services/tracking/trackers/utils";

export const trackCartStart = (cart: CartModel) => {
    ToolsStepTracker.track(
        TOOL_CHECKOUT_STEPS.cartStep,
        TOOL_CHECKOUT_CONTEXT,
        { cart: toCartImpressionTrackingInfo(cart) }
    );
};

export const trackLoginStart = (cart: CartModel) => {
    ToolsStepTracker.track(
        TOOL_CHECKOUT_STEPS.loginStep,
        TOOL_CHECKOUT_CONTEXT,
        { cart: toCartImpressionTrackingInfo(cart) }
    );
};

export const trackUserInfoStart = (cart: CartModel) => {
    ToolsStepTracker.track(
        {
            ...TOOL_CHECKOUT_STEPS.userInfoStep,
            result: { customerid: getUserInfo().clientID }
        },
        TOOL_CHECKOUT_CONTEXT,
        { cart: toCartImpressionTrackingInfo(cart) }
    );
};

export const trackPaymentStart = (cart: CartModel) => {
    ToolsStepTracker.track(
        {
            ...TOOL_CHECKOUT_STEPS.paymentStep,
            result: { customerid: getUserInfo().clientID }
        },
        TOOL_CHECKOUT_CONTEXT,
        { cart: toCartImpressionTrackingInfo(cart) }
    );
};

export const trackConfimationSubmit = (order: OrderDetailsModel) => {
    const deliveryMethods: Array<DeliveryType> = [];

    if (
        order.items.some((i) => i.deliveryType === DeliveryType.ClickAndCollect)
    ) {
        deliveryMethods.push(DeliveryType.ClickAndCollect);
    }

    if (order.items.some((i) => i.deliveryType === DeliveryType.HomeDelivery)) {
        deliveryMethods.push(DeliveryType.HomeDelivery);
    }

    const step: StepVariables = {
        ...TOOL_CHECKOUT_STEPS.confirmationStep,
        result: {
            customerid: getUserInfo().clientID,
            deliverymethod: deliveryMethods.join(",")
        }
    };

    const customerName = `${order.customer.firstName} ${order.customer.lastName}`;

    const cart = getOrderDetailsImpressionTrackingInfo({
        order: order,
        name: customerName
    });

    ToolsStepTracker.trackSubmit(step, TOOL_CHECKOUT_CONTEXT, { cart: cart });
};
